import { ResourceInfoDc } from "@evergis/api";
import { createAction, createReducer } from "redux-act";
import { reducerRegistry } from "../reducerRegistry";

const reducerName = "loader";

export interface LoaderState {
  layers: Partial<ResourceInfoDc>[];
}

const initialState: LoaderState = {
  layers: [],
};

export const reducer = createReducer<LoaderState>({}, initialState);

export const addLoadingLayer = createAction<Partial<ResourceInfoDc>>("loader/add-loading-layer");

export const removeLoadingLayer = createAction<string>("loader/remove-loading-layer");

reducer.on(addLoadingLayer, (state, newLayer) => ({
  ...state,
  layers: [...state.layers, newLayer],
}));

reducer.on(removeLoadingLayer, (state, layer) => {
  const deleteIndex = state.layers.findIndex(({ name }) => name === layer);
  const layers = [...state.layers];

  if (deleteIndex !== -1) {
    layers.splice(deleteIndex, 1);
  }

  return {
    ...state,
    layers,
  };
});

reducerRegistry.register(reducerName, reducer);
